// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { localize } from 'i18n-calypso'
import Map from 'church-theme-library/components/Map/Map'
import MapMarker from 'church-theme-library/components/Map/MapMarker'

// Internal Dependencies:
// import Image from 'church-theme-library/components/Image/Image'

class LocationAndMap extends React.Component {
	render() {
		const { contentId, sectionId, data, translate, locationAddress, locationURLPart, locationLat, locationLng, locationMapImage, siteFullName } = this.props
		let mapCenter

		if ( locationLat && locationLng ) {
			mapCenter = {
				lat: parseFloat( locationLat ),
				lng: parseFloat( locationLng )
			}
		}

		return (
			<div className="section-location-and-map">
				<div className="-inner">
					<div className="-content">
						<div className="-map">
							{ mapCenter &&
								<Map
									defaultCenter={ mapCenter }
									lat={ mapCenter.lat }
									lng={ mapCenter.lng }
									title={ siteFullName }
									subtitle={ locationAddress }
									staticImage={ locationMapImage }
								/>
							}

							{ locationAddress &&
								<div className="-location">
									<h3>{ translate( 'Find us at' ) }</h3>
									<p>{ locationAddress }</p>
									<p className="-sub"><a href={ `https://www.google.com/maps/dir/Current+Location/${locationURLPart}` } target="_blank" rel="noopener">({ translate( 'Get directions' ) })</a></p>
								</div>
							}
						</div>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		locationAddress: state.site.locationAddress,
		locationURLPart: state.site.locationURLPart,
		locationLat: state.site.locationLat,
		locationLng: state.site.locationLng,
		locationMapImage: state.site.locationMapImage,
		siteFullName: state.site.siteFullName
	}
}

export default localize(
	connect( mapStateToProps )( LocationAndMap )
)